'use client'

import { useEffect, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import SafeImage from './SafeImage'
import { rotatingReasons, whyUsClients, whyUsProjects } from '@/data/homepage'

export default function WhyUsSection() {
  const [projectIndex, setProjectIndex] = useState(0)
  const [reasonIndex, setReasonIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    const id = setInterval(() => {
      setAnimating(true)
      setTimeout(() => {
        setReasonIndex((prev) => (prev + 1) % rotatingReasons.length)
        setAnimating(false)
      }, 500)
    }, 3000)
    return () => clearInterval(id)
  }, [])

  const project = whyUsProjects[projectIndex]

  return (
    <section
      className="py-16 md:py-20 relative"
      style={{ background: 'linear-gradient(-45deg, #01124d 0%, #014b64 100%)' }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative h-[400px] md:h-[500px] rounded-lg overflow-hidden">
            {whyUsProjects.map((item, index) =>
              index === projectIndex ||
              index === (projectIndex + 1) % whyUsProjects.length ? (
              <div
                key={item.title}
                className={`absolute inset-0 transition-opacity duration-500 ${
                  index === projectIndex ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <SafeImage
                  src={item.image}
                  alt={item.title}
                  fill
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="object-cover"
                />
                <div className="absolute inset-0 bg-black/30" />
              </div>
              ) : null
            )}

            <button
              type="button"
              aria-label="Önceki proje"
              onClick={() =>
                setProjectIndex(
                  (prev) => (prev - 1 + whyUsProjects.length) % whyUsProjects.length
                )
              }
              className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              type="button"
              aria-label="Sonraki proje"
              onClick={() =>
                setProjectIndex((prev) => (prev + 1) % whyUsProjects.length)
              }
              className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronRight size={24} />
            </button>

            <div className="absolute bottom-0 left-0 right-0 bg-white p-6 z-10">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#c2410c] rounded text-white font-bold text-xl flex items-center justify-center shrink-0">
                  {String(projectIndex + 1).padStart(2, '0')}
                </div>
                <div>
                  <div className="text-[#232f3e] font-bold text-lg">{project.title}</div>
                  <div className="text-gray-600 text-sm">{project.description}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Neden mi Bizi Tercih Etmelisiniz?
            </h2>
            <div className="text-2xl font-bold text-[#fdba74] mb-8 flex flex-wrap items-center gap-2">
              <span>Çünkü</span>
              <span
                className={`text-white transition-all duration-500 ${
                  animating ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
                }`}
              >
                {rotatingReasons[reasonIndex]}
              </span>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {whyUsClients.map((client) => (
                <div
                  key={client}
                  className="bg-white/10 rounded-lg px-4 py-3 hover:bg-white/20"
                >
                  <div className="text-white text-sm font-semibold text-center">{client}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
